const LANG = 'se'
const LOCALE = 'sv'

// ? ******************************************************************************************
// ? ******************************************************************************************

const BRANDS = {
  ZMARTA: {
    ID: 2,
    BROKER_ID: -8,
    NAME: 'Zmarta',
    URL: 'https://www.zmarta.se',
    USER_AGREEMENT_URL: '/formansavtalet',
    USER_AGREEMENT_URL_EN: '/en/terms/benefit-agreement',
    APP_TERMS_URL: '/avtal/privatlan',
    APP_TERMS_URL_EN: '/en/terms/consumer-loan',
    DATA_CLUB_URL: '',
    REQUIREMENT_EMAIL: 'info@zmarta.se',
    PHONE: '0771-47 48 49'
  },
  BROKER: {
    ID: 1,
    BROKER_ID: -5,
    NAME: 'Freedom Finance',
    URL: 'https://www.freedomfinance.se',
    USER_AGREEMENT_URL: '/avtal/formansavtal',
    APP_TERMS_URL: '/avtal/privatlan',
    DATA_CLUB_URL: '',
    REQUIREMENT_EMAIL: 'info@freedomfinance.se',
    PHONE: '0431-47 47 00'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const MY_ACCOUNT = {
  BASE: {
    SV: '/mina-sidor',
    EN: '/en/my-pages'
  },
  PRODUCT: {
    SV: '/privatlan',
    EN: '/consumer-loan'
  },
  OFFERS: {
    SV: '/erbjudanden',
    EN: '/offers'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const AMOUNT_OF_LENDERS = 35

// ? ******************************************************************************************
// ? ******************************************************************************************

const AGE = {
  MAX: 100,
  MIN: 18
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const LOAN_AMOUNT = {
  MIN: 5000,
  MAX: 600000,
  STEP: 5000,
  DEFAULT: 250000,
  LEGAL_TEXT: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DURATION = {
  MIN: 1,
  MAX: 20,
  STEP: 1,
  DEFAULT: 14,
  LEGAL_TEXT: null
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PHONE_NO_GROUPING = {
  MIN_LENGTH: 10,
  REGEX: /(\d{4})(\d{2})(\d{2})(\d{2})/,
  OUTPUT: '$1 $2 $3 $4'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const ZOPIM = {
  ZMARTA: '2XnP6NPgSmQ2Kifrfc1BAtWe3VUinXHS',
  BROKER: '2uBWmkkPYoC5BVzNPUFSkHezSKlvDIzu'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const TIME_BASED_EMPLOYMENT = [3, 5]

// ? ******************************************************************************************
// ? ******************************************************************************************

const HAS_EMPLOYMENT = [1, 2, 3, 4, 5, 10]

// ? ******************************************************************************************
// ? ******************************************************************************************

const EXPERIMENT_EVENT_IDS = {
  LOAN_APPLICATION_DECLINED: {
    ZMARTA: 18227071960,
    BROKER: 20110834434
  },
  LOAN_APPLICATION_DUPLICATE: {
    ZMARTA: 18218370905,
    BROKER: 20137710382
  },
  LOAN_APPLICATION_USABLE: {
    ZMARTA: 18237720362,
    BROKER: 20123438414
  },
  LOAN_APPLICATION_FULL: {
    ZMARTA: 18192035573,
    BROKER: 20110185157
  },
  LOAN_APPLICATION_USABLE_CO_APPLICANT: {
    ZMARTA: 20014690905,
    BROKER: 20390205612
  },
  LOAN_APPLICATION_FULL_CO_APPLICANT: {
    ZMARTA: 20134835050,
    BROKER: 20373878852
  },
  LOAN_MYPAGES_READMORE: {
    ZMARTA: 18241690145,
    BROKER: 20408640321
  },
  LOAN_MYPAGES_SELECT: {
    ZMARTA: 18197725266,
    BROKER: 20098810000
  },
  LOAN_MYPAGES_SELECTED: {
    ZMARTA: 22578050916,
    BROKER: 22591380725
  },
  LOAN_MYPAGES_SIGNINGLINK: {
    ZMARTA: 18212590845,
    BROKER: 20104577869
  },
  LOAN_MYPAGES_REFINANCE_CONFIRM: {
    ZMARTA: 21494710521,
    BROKER: 21509101514
  },
  LOAN_MYPAGES_REFINANCE_DECLINE: {
    ZMARTA: 21488920531,
    BROKER: 21509101514
  },
  LOAN_MYPAGES_SELECT_EID_LOGIN: {
    ZMARTA: 22537580134,
    BROKER: 22561200429
  },
  LOAN_APPLICATION_PREFILL_DATA: {
    ZMARTA: 23472491767,
    BROKER: 23598100173
  },
  LOAN_APPLICATION_REAPPLY: {
    ZMARTA: 23472501649,
    BROKER: 23505872489
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PRODUCT_SLUGS = {
  PRIVATE_LOAN: '/privatlan',
  REFINANCE_LOAN: '/samla-lan',
  CAR_LOAN: '/billan'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const SSNS = {
  DECLINED: '610508-8667',
  CF: '670130-0417'
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const FIELDS_THAT_ALLOW_0 = [
  'children',
  'monthlyIncome'
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const CURRENCY = {
  sv: {
    currency: 'kr',
    format: '{amount} {currency}'
  },
  en: {
    currency: 'SEK',
    format: '{currency} {amount}'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const NUMBERS = {
  sv: {
    thousandSeparator: ' ',
    decimalSign: ','
  },
  en: {
    thousandSeparator: ',',
    decimalSign: '.'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const RATE = '%'

// ? ******************************************************************************************
// ? ******************************************************************************************

const GOOGLE_ANALYTICS = {
  NAME: {
    ZMARTA: 'owned',
    BROKER: 'freedomfinance'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const BANKS = {
  SPARBANKEN_ORESUND: 10,
  SWEDBANK: 11,
  SPARBANKEN_FRISTAENDE: 40,
  SPARBANKEN_SYD: 150,
  SPARBANKEN_SKANE: 158,
  KOMPLETT: 116,
  CREDWAY: 118,
  SEVENDAY: 16
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const FIVE_DIGIT_CLEARING_NO = [
  BANKS.SPARBANKEN_ORESUND,
  BANKS.SPARBANKEN_FRISTAENDE,
  BANKS.SPARBANKEN_SYD,
  BANKS.SPARBANKEN_SKANE
]

// ? ******************************************************************************************
// ? ******************************************************************************************

const ALTERNATE_INTEREST_RATE_LIMIT = 0

// ? ******************************************************************************************
// ? ******************************************************************************************

const URLS = {
  ZMARTA: {
    APPLICATION: '/lana-pengar/privatlan',
    CONTINUE_APPLICATION: '/lana-pengar/privatlan/fortsatt-ansokan',
    ADD_CO_APPLICANT: '/lana-pengar/privatlan/lagg-till-medsokande'
  },
  BROKER: {
    APPLICATION: '/privatlan/ansok',
    CONTINUE_APPLICATION: '/privatlan/fortsatt-ansokan',
    ADD_CO_APPLICANT: '/privatlan/lagg-till-medsokande'
  }
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const REQUIREMENTS = {}

// ? ******************************************************************************************
// ? ******************************************************************************************

const PAYOUT_SPAN = '1-3'

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_DEFAULTS = {
  carLoan: 0,
  chargeCard: 0,
  creditCard: 0,
  mortgage: 104,
  otherLoan: 0,
  studentLoan: 0
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const DEBT_REGISTRY_MAP = {
  loan: {},
  credit: {}
}

// ? ******************************************************************************************
// ? ******************************************************************************************

const HIDE_OPTIONS = {
  socialEconomicStatus: [],
  residenceType: [],
  residenceOwnershipType: [4],
  otherLoanType: []
}

// ? ******************************************************************************************
// ? ******************************************************************************************

module.exports = {
  LANG,
  LOCALE,
  BRANDS,
  MY_ACCOUNT,
  AMOUNT_OF_LENDERS,
  AGE,
  LOAN_AMOUNT,
  DURATION,
  PHONE_NO_GROUPING,
  ZOPIM,
  TIME_BASED_EMPLOYMENT,
  HAS_EMPLOYMENT,
  EXPERIMENT_EVENT_IDS,
  PRODUCT_SLUGS,
  SSNS,
  FIELDS_THAT_ALLOW_0,
  CURRENCY,
  NUMBERS,
  GOOGLE_ANALYTICS,
  BANKS,
  FIVE_DIGIT_CLEARING_NO,
  ALTERNATE_INTEREST_RATE_LIMIT,
  URLS,
  REQUIREMENTS,
  RATE,
  PAYOUT_SPAN,
  DEBT_DEFAULTS,
  DEBT_REGISTRY_MAP,
  HIDE_OPTIONS
}
